/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Practice_Meta_From_ChatInputs */



/**
* | output |
* | --- |
* | "from your chat of {date}" |
*
* @param {Practice_Meta_From_ChatInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_meta_from_chat = /** @type {((inputs: Practice_Meta_From_ChatInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Meta_From_ChatInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`uit je chat van ${i?.date}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`issu de votre chat du ${i?.date}`)
	return /** @type {LocalizedString} */ (`from your chat of ${i?.date}`)
});